import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { TrackingLinkDto } from '../../../helpers/types';
import { trackingLinksService } from '../../../services/tracking-links.service';

export const fetchTrackingLinks = createAsyncThunk<
  { creatorId: string; trackingLinks: TrackingLinkDto[], key: string },
  { creatorId: string; status?: string },
  { rejectValue: { message: string } }
>(
  'trackingLinks/fetchTrackingLinks',
  async ({ creatorId, status = 'active' }, { rejectWithValue }) => {
    try {
      const trackingLinks = await trackingLinksService.getTrackingLinks({ status });
      const key = `${creatorId}__${status}`;

      return { creatorId, trackingLinks, key };
    } catch (err) {
      const error = err as AxiosError<any>;
      return rejectWithValue({ message: (error.response?.data as any)?.message || 'Failed to load tracking links' });
    }
  }
);

export const createTrackingLinkAction = createAsyncThunk<
  { creatorId: string; trackingLink: TrackingLinkDto },
  { creatorId: string; title: string },
  { rejectValue: { message: string } }
>('trackingLinks/createTrackingLink', async ({ creatorId, title }, { rejectWithValue }) => {
  try {
    const trackingLink = await trackingLinksService.createTrackingLinks({ title });
    return { creatorId, trackingLink };
  } catch (err) {
    const error = err as AxiosError<any>;
    return rejectWithValue({ message: (error.response?.data as any)?.message || 'Failed to create tracking link' });
  }
});

export const updateTrackingLinkAction = createAsyncThunk<{ id: string; name: string }, { id: string; name: string }, { rejectValue: { message: string } }>(
  'trackingLinks/updateTrackingLink',
  async ({ id, name }, { rejectWithValue }) => {
    try {
      await trackingLinksService.updateTrackingLink(id, { name });
      return { id, name };
    } catch (err) {
      const error = err as AxiosError<any>;
      return rejectWithValue({ message: (error.response?.data as any)?.message || 'Failed to update tracking link' });
    }
  }
);

export const deleteTrackingLinkAction = createAsyncThunk<{ id: string }, { id: string }, { rejectValue: { message: string; status?: number } }>(
  'trackingLinks/deleteTrackingLink',
  async ({ id }, { rejectWithValue }) => {
    try {
      const success = await trackingLinksService.deleteTrackingLink(id);
      if (!success) throw new Error('Delete failed');
      return { id };
    } catch (err) {
      const error = err as AxiosError<any>;
      return rejectWithValue({ message: (error.response?.data as any)?.message || 'Failed to delete tracking link', status: error.response?.status });
    }
  }
);